import { Card } from '@ipfabric/ui-components/Card/Card';
import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { VendorsApiFieldValues } from '../../snippets/storedVendorsApi';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  form: UseFormReturn<VendorsApiFieldValues>;
  renderSnippet: (name: 'storedVendorsApi') => ReactNode;
};

export const VendorsApi = (props: Props) => (
  <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
    <SearchableSection
      id='vendors-api'
      className='flex flex-col flex-1 p'
      searchTerms={['Vendor APIs']}
      wrapperClassName='flex flex-col flex-1'
    >
      {props.renderSnippet('storedVendorsApi')}
    </SearchableSection>
  </Card>
);
